var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"cx_badge_user",class:_vm.bgcolor},[_vm._v(_vm._s(this.initial))])}
var staticRenderFns = []

export { render, staticRenderFns }